module.exports = __webpack_public_path__ + "img/strictness_data_uploading.102fe11.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/strictness_data_uploading.svg
// module id = jVd0
// module chunks = 1